import { IPublicTypeContainerSchema } from './';

/**
 * 区块容器
 * @see https://lowcode-engine.cn/lowcode
 */

export interface IPublicTypeBlockSchema extends IPublicTypeContainerSchema {
  componentName: 'Block';
}
